"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgQrCode = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M2 2h9v9H2V2zm2 2h5v5H4V4zm4 1H5v3h3V5zm-6 8h9v9H2v-9zm2 2h5v5H4v-5zm4 1H5v3h3v-3zM22 2h-9v9h9V2zm-2 2h-5v5h5V4zm-4 1h3v3h-3V5zm-3 8h3v1h-1v3h1v1h-1v3h1v1h-3v-9zm7 0h-3v2h3v-2zm-3 3h2v1h-1v2h1v1h-2v-4zm5-3h-1v2h1v-2zm-5 8h1v1h-1v-1zm3 0h-1v1h3v-6h-2v5z' }))); };
exports.default = SvgQrCode;
//# sourceMappingURL=QrCode.js.map